import { render, staticRenderFns } from "./CourseDetailForm.vue?vue&type=template&id=5d7012d8&"
import script from "./CourseDetailForm.vue?vue&type=script&lang=js&"
export * from "./CourseDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports